<template>
    <div>
      <el-dialog
        title="账号登录"
        :visible="lState"
        @close='closeLogin'
        width="500px"
        center>
        <el-form :model="ruleForm2" :rules='rules' ref="ruleForm2">
          <el-form-item label="迷你号" prop="uin" >
            <el-input  v-model="ruleForm2.uin" style='width: 270px;'></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input v-model.number="ruleForm2.code" style='width: 150px;'></el-input>
            <el-button type="primary" @click='getCode' :disabled='codeBtnName.flag'>{{codeBtnName.name}}</el-button>
          </el-form-item>
          <el-form-item style='margin-left: 50px;margin-top: 25px;'>
            <el-button type="primary" @click="submitForm('ruleForm2')">登录</el-button>
            <el-button @click="resetForm('ruleForm2')">重置</el-button>
          </el-form-item>
          <p class='font2'>验证码获取方式：输入迷你号，点击“发送验证码”按钮，登录游戏内邮箱获取。</p>
        </el-form>
      </el-dialog>
    </div>
</template>

<script>
    export default {
      name: "Login",
      props: {
        lState: Boolean
      },
      data() {
        return {
          codeBtnName: {
            name: "发送验证码",
            num: 60,
            timer: null,
            flag: false
          },
          ruleForm2: {
            uin: window.localStorage.getItem('uin') || '',
            code: ''
          },
          rules: {
            uin: [
              { required: true, message: "请输入迷你号", trigger: "blur"},
              { message: "迷你号只能是数字", pattern: /^\d+$/, trigger: "change"}
            ],
            code: [
              { required: true, message: "请输入验证码", trigger: "blur"}
            ]
          }
        };
      },
      mounted () {

      },
      methods: {
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.$http.get('open/auth/authCode',{
                params: {
                  uin: this.ruleForm2.uin,
                  code: this.ruleForm2.code
                }
              }).then(rel => {
                if (rel.data.code == 'SUCCESS') {
                  // 如果登录成功
                  this.closeLogin();
                  this.$emit('success',true) // 登录成功
                  this.$emit('userinfo',rel.data.authinfo) // 传递个人信息
                  window.sessionStorage.setItem('loginStatus',true)
                  window.sessionStorage.setItem('authinfo',JSON.stringify(rel.data.authinfo))
                  // 登录成功记住账号
                  window.localStorage.setItem('uin',this.ruleForm2.uin)
                }else if (rel.data.code == '401') {
                  this.$message.error('请输入正确的迷你号或验证码');
                }else if (rel.data.code == 'FAIL') {
                  this.$message.error('验证码错误');
                }
              })
            }
          });
        },
        getCode () {
            this.$refs.ruleForm2.validateField('uin',(err) => {
              // 如果迷你号为空
                if (!!err) {
                  this.$message.error('请输入迷你号');
                }else {
                  this.$http.get('open/auth/getCode',{
                   params: {
                     uin: this.ruleForm2.uin,
                     title: "迷你积分登录验证码"
                   }
                 }).then(rel => {
                   if (rel.data.code == 402) {
                     this.$message.error('请输入正确的迷你号');
                   }else if (rel.data.code == 'SUCCESS') {
                     this.codeBtnName.flag = true;
                     this.codeBtnName.timer = setInterval(this.sendCode,1000)
                     this.$message({
                       message: '发送成功，请到游戏内查收',
                       type: 'success'
                     });
                   }
                 }).catch(err => {
                   console.log(err);
                 })
                }
            })
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        },
        closeLogin () {
          this.$emit('closeLogin',false)
          // 关闭弹窗后还原状态
          this.ruleForm2.code = "";
          this.codeBtnName.name = "发送验证码";
          this.codeBtnName.flag = false;
          clearInterval(this.codeBtnName.timer);  // 清除定时器
          this.codeBtnName.num = 60;
        },
        sendCode () {
          this.codeBtnName.num--;
          if(this.codeBtnName.num >= 0 )
          {
            this.codeBtnName.name =  `还剩余${this.codeBtnName.num}秒`;
          }
          else
          {
            this.codeBtnName.name = "重新发送验证码";
            this.codeBtnName.flag = false;
            clearInterval(this.codeBtnName.timer);  // 清除定时器
            this.codeBtnName.num = 60;
          }
        },
      }
    }
</script>

<style scoped>
.font {
  color: rgb(153, 153, 153);;
}
.font2 {
  color: #f00;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue